import { Leg, Trip, Waiver } from "../../js/headersegment/interfaces";
import { scrollTo } from "../lib/trip";
import _ from "lodash";
import React, { useEffect, useState } from 'react';

interface TripWaiversProps {
  trip: Trip;
}

interface WaiverDisplay {
  key: string;
  id: string;
  name: string;
  issuer: string;
  leg: number;
}

const TripWaivers: React.FC<TripWaiversProps> = ({ trip }) => {
  const [waivers, setWaivers] = useState<WaiverDisplay[]>([]);

  useEffect(() => {
    extractWaiversFromTrip(trip);
  }, [trip]);

  const extractWaiversFromTrip = (trip: Trip) => {
    const waivers = trip.legs.flatMap((leg, legIndex) => getWaiversForLeg(leg, legIndex + 1));
    setWaivers(waivers);
  };

  const getWaiversForLeg = (leg: Leg, legNumber: number): WaiverDisplay[] => {
    return _(leg.flights)
      .filter('waiverMatches')
      .flatMap('waiverMatches')
      .map('waiver')
      .map((waiver: Waiver) => ({
        key: `${waiver.id}-${legNumber}`,
        id: waiver.id,
        name: waiver.name,
        issuer: waiver.issuingAirlineCode,
        leg: legNumber,
      }))
      .uniqBy('key')
      .value() as any;
  };

  return (
    <div className="widget">
      <div className="header">APPLICABLE WAIVERS</div>
      <div className="data-header">
        <table className="table table-condensed">
          <thead>
            <tr>
              <th className="left waiver-leg">LEG</th>
              <th className="left waiver-name">NAME</th>
              <th className="waiver-issuer">ISSUER</th>
            </tr>
          </thead>
        </table>
      </div>
      <div className="data">
        <table className="table table-condensed">
          <tbody>
            {waivers.map(waiver => (
              <tr key={waiver.key}>
                <td className="table-entry waiver-leg">
                  <a href="#" onClick={(event: any) => scrollTo(`leg-${waiver.leg}`, event)}>{waiver.leg}</a>
                </td>
                <td className="table-entry waiver-name">
                  <a href={`/waivers/${waiver.id}`}>{waiver.name}</a>
                </td>
                <td className="table-entry waiver-issuer center-value">{waiver.issuer}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TripWaivers;